export type DemoSortKey = 'featured' | 'plugin' | 'recent';

export interface UseCaseDemoConfig {
  id: string;
  /** MP4 URL — leave null until uploaded */
  videoUrl: string | null;
  /** Optional poster frame */
  posterUrl?: string | null;
  /** Accent hue for avatar fallback (0–360) */
  accentHue: number;
  /** Placeholder engagement stats */
  views: number;
  likes: number;
}

/**
 * 统一的媒体路径规则（OSS CDN）：
 * - 视频：https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/{id}.mp4
 * - 缩略图：https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/{id}.png
 */
const USE_CASE_MEDIA_BASE =
  'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/';

export function useCaseMedia(id: string): { videoUrl: string; posterUrl: string } {
  return {
    videoUrl: `${USE_CASE_MEDIA_BASE}${id}.mp4`,
    posterUrl: `${USE_CASE_MEDIA_BASE}${id}.png`,
  };
}

export const USE_CASE_DEMOS: UseCaseDemoConfig[] = [
  // {
  //   id: 'cohort-retention',
  //   videoUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/cohort-retention.mp4',
  //   posterUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/cohort-retention.png',
  //   accentHue: 248,
  //   views: 0,
  //   likes: 0,
  // },
  {
    id: 'pdf-semantic-search',
    videoUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/pdf-semantic-search.mp4',
    posterUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/pdf-semantic-search.png',
    accentHue: 210,
    views: 0,
    likes: 0,
  },
  {
    id: 'sql-explore-visualize',
    videoUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/sql-explore-visualize.mp4',
    posterUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/sql-explore-visualize.png',
    accentHue: 165,
    views: 0,
    likes: 0,
  },
  {
    id: 'embed-files',
    videoUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/embed-files.mp4',
    posterUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/embed-files.png',
    accentHue: 32,
    views: 0,
    likes: 0,
  },
  // {
  //   id: 'interactive-dashboard',
  //   videoUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/interactive-dashboard.mp4',
  //   posterUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/interactive-dashboard.png',
  //   accentHue: 280,
  //   views: 0,
  //   likes: 0,
  // },
  // {
  //   id: 'research-corpus',
  //   videoUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/research-corpus.mp4',
  //   posterUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/research-corpus.jpeg',
  //   accentHue: 195,
  //   views: 0,
  //   likes: 0,
  // },
  {
    id: 'file-format-convert',
    videoUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/file-format-convert.mp4',
    posterUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/file-format-convert.png',
    accentHue: 275,
    views: 0,
    likes: 0,
  },
  // {
  //   id: 'web-data-query',
  //   videoUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/web-data-query.mp4',
  //   posterUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/web-data-query.png',
  //   accentHue: 15,
  //   views: 0,
  //   likes: 0,
  // },
  // {
  //   id: 'agent-orchestration',
  //   videoUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/agent-orchestration.mp4',
  //   posterUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/agent-orchestration.png',
  //   accentHue: 340,
  //   views: 0,
  //   likes: 0,
  // },
  // {
  //   id: 'hub-plugin-install',
  //   videoUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/hub-plugin-install.mp4',
  //   posterUrl: 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa/assets/use-cases/hub-plugin-install.png',
  //   accentHue: 120,
  //   views: 0,
  //   likes: 0,
  // },
];
